module.exports = __webpack_public_path__ + "img/case-3.ad02a97.png";